import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';

export namespace NCustomerGroups {
    export interface IOption extends NICmsContentField.IOption<TId> {}

    export type TId = number | 'all';

    export const NOT_LOGGED_IN_CUSTOMER_OPTION: IOption = {
        title: 'Not logged in',
        key: 0
    };

    export const ALL_CUSTOMER_OPTION: IOption = {
        title: 'All',
        key: 'all'
    };
}

export const CUSTOMER_GROUPS: NCustomerGroups.IOption[] = [
    { title: 'General', key: 1 },
    { title: 'Trade', key: 2 },
    { title: 'Trade prospect', key: 3 },
    { title: 'Trade10', key: 25 },
    { title: 'Trade15', key: 26 },
    { title: 'Trade3', key: 27 },
    { title: 'Trade5', key: 28 },
    { title: 'Black friday vip', key: 30 },
    { title: 'Audtrade10', key: 31 },
    { title: 'Disteu', key: 32 },
    { title: 'Trade8', key: 33 },
    { title: 'Staff', key: 34 },
    { title: 'Jrstrade', key: 35 },
    { title: 'Jrstrade4', key: 36 },
    { title: 'Jrstrade5', key: 37 },
    { title: 'Jrstrade6', key: 38 },
    { title: 'Jrstrade10', key: 39 },
    { title: 'Tradedap', key: 40 },
    { title: 'Rrpddp', key: 41 },
    { title: 'Tradeddp', key: 42 },
    { title: 'Sponsrider', key: 44 },
    { title: 'Tier 1 - Enthusiast', key: 46 },
    { title: 'Tier 2 - Rising Star', key: 47 },
    { title: 'Tier 3 - Pro', key: 48 },
    { title: 'Tier 4 - Elite', key: 49 },
    { title: 'Tier 5 - Legend', key: 50 },
    { title: 'Tier 6 - Insider', key: 51 },
    { title: 'EURTRADE10', key: 52 },
    { title: 'TRADEUSD5', key: 53 },
    { title: 'TRADEEUR5', key: 54 },
    { title: 'STAFFUSA', key: 55 },
    { title: 'Helmet Judges', key: 56 }
];
export const customerGroupVisibilityCmsField = (customerGroups: NCustomerGroups.IOption[] = [], multiple = true) => {
    const groups: NCustomerGroups.IOption[] = [
        NCustomerGroups.ALL_CUSTOMER_OPTION,
        NCustomerGroups.NOT_LOGGED_IN_CUSTOMER_OPTION,
        ...customerGroups
    ];

    return {
        key: 'visibility',
        type: NICmsContentField.EFieldType.choice,
        title: 'Visibility',
        options: () => {
            if (!multiple) {
                return [...UndefinedOption, ...groups];
            }

            return groups;
        },
        default: [NCustomerGroups.ALL_CUSTOMER_OPTION.key],
        multiple
    };
};

export function isCustomerAllowed(allowed: NCustomerGroups.TId | NCustomerGroups.TId[] | undefined, groupId?: number): boolean {
    const _allowed = Array.isArray(allowed) ? allowed : [allowed];

    if (_allowed.indexOf(NCustomerGroups.ALL_CUSTOMER_OPTION.key) > -1) {
        return true;
    }

    if (groupId) {
        return _allowed.indexOf(groupId) > -1;
    }

    return _allowed.indexOf(NCustomerGroups.NOT_LOGGED_IN_CUSTOMER_OPTION.key) > -1;
}
